import LogUtils from "../utils/log-utils.ts";
import CACHE_BUSTER from "../../../../cache-buster.json" with { type: "json" };

export default class BaseHtmlElement extends HTMLElement {
  protected readonly debug: boolean;
  protected readonly uniqueId: string;
  protected readonly container: HTMLDivElement;
  protected readonly popUpNotificationContainer: HTMLDivElement;
  protected readonly shadowRealm: ShadowRoot;

  constructor(uniqueId: string) {
    super();

    // set debug mode
    this.debug = globalThis.location.hostname === "localhost";

    // set ID
    this.uniqueId = uniqueId;

    // get the shadow root
    this.shadowRealm = this.attachShadow({ mode: "closed" });

    // add style
    const style: HTMLLinkElement = document.createElement("link");
    style.rel = "stylesheet";
    style.type = "text/css";
    style.href = CACHE_BUSTER["static/stylesheet/main.css"];
    this.shadowRealm.appendChild(style);

    // create container div that all screen content will live
    this.container = document.createElement("div");
    this.container.id = this.uniqueId;
    this.shadowRealm.appendChild(this.container);

    // create container div for pop-up notifications
    this.popUpNotificationContainer = document.createElement("div");
    this.popUpNotificationContainer.id = "pop-up-notification-container";
    this.shadowRealm.appendChild(this.popUpNotificationContainer);
  }

  protected render(newElements: HTMLElement[] = []) {
    this.container.replaceChildren(...newElements);
  }

  connectedCallback() {
    LogUtils.debug(this.debug, `Component Connected: ${this.uniqueId}`);
  }

  disconnectedCallback() {
    LogUtils.debug(this.debug, `Component Disconnected: ${this.uniqueId}`);
  }
}
